
import { useEffect, useState } from 'react';

export const useMotivationalEffects = (specialEffects?: string) => {
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    if (specialEffects) {
      triggerEffect(specialEffects);
    }
  }, [specialEffects]);

  const triggerEffect = (effect: string) => {
    switch (effect) {
      case 'glitch':
        setIsGlitching(true);
        setTimeout(() => setIsGlitching(false), 500);
        break;
      case 'pulse':
        // CSS animation will handle this
        break;
      case 'shake':
        // CSS animation will handle this
        break;
      default:
        break;
    }
  };

  const getEffectClass = () => {
    const effects = [];
    
    if (specialEffects) {
      effects.push(`motivational-effect-${specialEffects}`);
    }
    
    if (isGlitching) {
      effects.push('motivational-glitch-active');
    }
    
    return effects.join(' ');
  };

  return { getEffectClass };
};
